import AppModal from './NewsletterModal.vue';

const Modal = {
    // eslint-disable-next-line no-unused-vars
    install(Vue, options) {
        this.EventBus = new Vue();
        Vue.component(AppModal.name, AppModal);
        Vue.prototype.$newsletter = {
            show(params){
                Modal.EventBus.$emit('show', params);
            }
        }
    }
};

export default Modal;